export default __webpack_public_path__ + "9ed82c1ccd2996bca37d2d119f575295.svg";